export const projectEntry = {
  slug: "wxyz-blocks",
  name: "WXYZ Blocks",
  description:
    "A developer-focused WordPress plugin that bundles multiple Gutenberg blocks under a single plugin, plus a lightweight framework structure to help maintain many blocks in one codebase.",
  repoUrl: "https://github.com/sarahcssiqueira/wxyz-blocks",
  downloadUrl: "https://github.com/sarahcssiqueira/wxyz-blocks/archive/HEAD.zip",
  forkUrl: "https://github.com/sarahcssiqueira/wxyz-blocks/fork",
  readmeUrl: "https://github.com/sarahcssiqueira/wxyz-blocks#readme-ov-file",
};

export default function PagePWXZ() {
 const pluginData = projectEntry;

  return (
    <>
    <main className="max-w-6xl mx-auto px-6 py-12 text-slate-800 font-sans space-y-2">
      <h2 className="m-0 text-3xl font-semibold text-center text-purple-800">
            WXYZ Blocks
      </h2>
      <p className="m-0 text-sm text-slate-600 text-center">
        {pluginData.description}
      </p>

        <div className="w-full flex flex-col items-center gap-4">
          <a
            className="inline-flex items-center justify-center rounded-md bg-purple-700 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-purple-800"
            href={pluginData.downloadUrl}
            aria-label={`Download ${pluginData.name} on GitHub`}
          >
            Download
          </a>
          <div className="flex flex-wrap items-center justify-center gap-3 text-sm">
            <a
              className="inline-flex items-center gap-2 rounded-md border border-purple-700 px-4 py-2 text-purple-700 transition hover:bg-purple-50"
              href={pluginData.repoUrl}
              aria-label={`Star ${pluginData.name} on GitHub`}
            >
              <i className="fa-regular fa-star text-purple-600"></i> Star Repo
            </a>
            <a
              className="inline-flex items-center gap-2 rounded-md border border-purple-700 px-4 py-2 text-purple-700 transition hover:bg-purple-50"
              href={pluginData.readmeUrl}
              aria-label={`Readme ${pluginData.name} on GitHub`}
            >
              <i className="fa-solid fa-book-open text-purple-600"></i> Readme
            </a>
            <a
              className="inline-flex items-center gap-2 rounded-md border border-purple-700 px-4 py-2 text-purple-700 transition hover:bg-purple-50"
              href={pluginData.forkUrl}
              aria-label={`Fork ${pluginData.name} on GitHub`}
            >
              <i className="fa-solid fa-code-fork text-purple-600"></i> Fork Code
            </a>
          </div>

          <p className="text-sm text-slate-600">Happy coding!</p>
        </div>
      </main>
    </>
  );
}

